export default {
    500: '处理您的信息流时遇到异常，可能是网络原因，您可稍后再试一下。',
    90002: "没有查询到结果",
    190002: "已超过当日使用次数，请明日再来，或升级会员",
    // 90001: "我勒个去这就挂了啊",
    // 10001: "我勒个去这就挂了啊",
    // 404: "我勒个去这就挂了啊"
};